/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FusionActionConf } from './fusionActionConf';


export interface GroupConf { 
    byField?: string;
    fusionActions?: Array<FusionActionConf>;
    groupOperator?: GroupConf.GroupOperatorEnum;
    valueOperator?: string;
}
export namespace GroupConf {
    export type GroupOperatorEnum = 'ADITION' | 'EQUALS';
    export const GroupOperatorEnum = {
        ADITION: 'ADITION' as GroupOperatorEnum,
        EQUALS: 'EQUALS' as GroupOperatorEnum
    };
}
